export const SEARCH_ROOM_ASYNC = 'SEARCH_ROOM_ASYNC';
export const SEARCH_ROOM_SUCCESS = 'SEARCH_ROOM_SUCCESS';
export const CREATE_ROOM_ASYNC = 'CREATE_ROOM_ASYNC';
export const UPDATE_ROOM_ASYNC = 'UPDATE_ROOM_ASYNC';
export const UPDATE_DEFAULT_CONFIGS_ASYNC = 'UPDATE_DEFAULT_CONFIGS_ASYNC';
export const MAKE_ACTIVE_ROOM_ASYNC = 'MAKE_ACTIVE_ROOM_ASYNC';
export const MAKE_INACTIVE_ROOM_ASYNC = 'MAKE_INACTIVE_ROOM_ASYNC';
export const OPEN_FORM_CREATE_ROOM = 'OPEN_FORM_CREATE_ROOM';
export const CLOSE_FORM_CREATE_ROOM = 'CLOSE_FORM_CREATE_ROOM';
export const GET_ROOM_BY_ID_ASYNC = 'GET_ROOM_BY_ID_ASYNC';
export const GET_ROOM_BY_ID_SUCCESS = 'GET_ROOM_BY_ID_SUCCESS';
export const ADD_EDIT_ROOM_ERROR = 'ADD_EDIT_ROOM_ERROR';
export const RESET_ROOM = 'RESET_ROOM';
export const SELECT_LIST_ROOM_ASYNC = 'SELECT_LIST_ROOM_ASYNC';
export const FETCH_HOMEOWNER_ROOM_SELECT_LIST_ASYNC = 'FETCH_HOMEOWNER_ROOM_SELECT_LIST_ASYNC';
export const FETCH_HOMEOWNER_ROOM_SELECT_LIST_SUCCESS = 'FETCH_HOMEOWNER_ROOM_SELECT_LIST_SUCCESS';




// WEBPACK FOOTER //
// ./src/Rooms/constants.js